/**
 * @name APP integration
 * @autor jaime.salazar@u-planner.com
 * @description
 * rutas modulo tablas de filtrado
 */

//Inyectamos la dependencias necesarias de angular para generar las rutas;

routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

//funcion donde se definen la rutas

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	
  $stateProvider
    .state('app.tableint_campus', {
      url: '/tableintcampus?:type',
      abstract: false,
      params:{type:'campus'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_periodo', {
      url: '/tableintperiodo?:type',
      abstract: false,
      params:{type:'PeriodoAcademico'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_horaClase', {
      url: '/tableinthoraClase?:type',
      abstract: false,
      params:{type:'jornada'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_infraestructura', {
      url: '/tableintinfraestructura?:type',
      abstract: false,
      params:{type:'Recurso'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_infraestructuratipouso', {
      url: '/tableintinfraestructuratipouso?:type',
      abstract: false,
      params:{type:'Recurso_Tipouso'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_planestudioasignatura', {
      url: '/tableintplanestudioasignatura?:type',
      abstract: false,
      params:{type:'curso_planestudio'},//?
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_planestudioturno', {
      url: '/tableintplanestudioturno?:type',
      abstract: false,
      params:{type:'CampusperiodojornadaPlan'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_actividadasignaturadetalle', {
      url: '/tableintactividadasignaturadetalle?:type',
      abstract: false,
      params:{type:'Curso_Actividad'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_actividadasignaturatipouso', {
      url: '/tableintactividadasignaturatipouso?:type',
      abstract: false,
      params:{type:'curso_actividad_tipouso'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_valorhoraasignatura', {
      url: '/tableintvalorhoraasignatura?:type',
      abstract: false,
      params:{type:'ValorHoraCurso'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_arancelcarrera', {
      url: '/tableintarancelcarrera?:type',
      abstract: false,
      params:{type:'ArancelCarrera'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_docente', {
      url: '/tableintdocente?:type',
      abstract: false,
      params:{type:'Docente'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_docenteasignaturaactividadsede', {
      url: '/tableintdocenteasignaturaactividadsede?:type',
      abstract: false,
      params:{type:'DocenteCursoActividad'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_docentevalorhoraevaluacion', {
      url: '/tableintdocentevalorhoraevaluacion?:type',
      abstract: false,
      params:{type:'DocenteValorHoraEvaluacion'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    .state('app.tableint_notaclase', {
      url: '/tableintnotaclase?:type',
      abstract: false,
      params:{type:'Nota_Clase'},
      template: require('./tableint.html'),
      controller: 'tableintCtrl',
      controllerAs: 'tableint'  
    })
    ;
}


// WEBPACK FOOTER //
// ./src/app/integration-front/tablesint/tablesint.route.js